module.exports = __webpack_public_path__ + "img/ressource-03.4ffcae0b.svg";